/**
  从二级菜单开始展示
**/
<template>
  <div class="selectBox" @mouseleave="setShow(0, 0)">
    <div class="noTypeList" v-if="this.data.length <= 0">
      暂无数据~
    </div>
    <!-- 一级菜单 -->
    <ul class="typeList"
        v-if="this.data.length > 0"
        @mouseleave="setShow(0, 0)">
      <li class="liItem"
          v-for="item in this.data" :key="item.value"
          :class="{liActive : typeSelectItem === item.value}"
          @mouseenter="getFatherValue(item)">
        {{ item.label }}
        <i class="el-icon-arrow-right"/>
      </li>
    </ul>
    <!-- 二级菜单 -->
    <ul class="typeList"
        v-if="typeSon.length > 0 && showTypeSon"
        @mouseenter="setShow(1, 0)">
      <li class="liItem"
          v-for="item in typeSon" :key="item.value"
          :class="{liActive : typeSonSelectItem === item.value}"
          @mouseenter="getProValue(item)">
        {{ item.label }}
        <i class="el-icon-arrow-right"/>
      </li>
    </ul>
    <!-- 检测项目列表 -->
    <div v-if="showProList"
         @mouseenter="setShow(1, 1)">
      <ul class="typeItemContainer" v-if="proList.length > 0">
        <li class="sonItem"
            v-for="item in this.proList"
            :key="item.id"
            @click="selectTypeItem(item)"
            :title="item.storeName">
          <span>{{ item.storeName }}</span>
        </li>
      </ul>
      <div class="typeItemContainer NoChildren" v-if="proList.length <= 0">
        <NotFoundInfo/>
      </div>
    </div>
  </div>
</template>

<script>
// api
import {
  getProducts
} from '@/api/indexpage.js'
// method
import { _throttle } from '@/util/common.js'
// components
import NotFoundInfo from '@/components/NotFound/NotFoundInfo.vue'
// util
import { _debounce } from '@/util/common.js'
export default {
  components: {
    NotFoundInfo
  },
  props: {
    data: {
      typeof: Array,
      default: []
    },
    typeSelect: {
      typeof: String,
      default: ''
    }
  },
  data () {
    return {
      typeSelectItem: this.typeSelect, // 父级id
      typeSonSelectItem: '', // 子级id
      typeSon: [],  // 子级列表
      proList: [],  // 商品列表
      showTypeSon: false,
      showProList: false,  // 展示商品列表框
      // 标题隐藏防抖
      delay: 100,
      timeFlag: null,
      // 二级标题更新防抖
      delay1: 100,
      timeFlag1: null,
      // 商品请求
      listQuery: {
        'isIntegral': 0, // 是否积分兑换商品 0否  1是
        'keyword': '', // 关键
        'news': '', // 是否新品  0否  1是
        'priceOrder': '', // 价格排序
        'salesOrder': '', // 销量排序
        'sid': '', // 分类ID
        'type': '', // 类别 不传
        'limit': 32,
        'page': 1
      }
    }
  },

  methods: {
    // 防抖更新二级标题列表
    getFatherValue2: _debounce(this.timeFlag1, function(item) {
      this.getFatherValue(item);
    }, this.delay1),
    // 二级标题列表更新
    getFatherValue (item) {
      // console.log(item);
      // 展示二级标题，不展示三级标题
      this.setShow(1, 0);
      this.typeSelectItem = item.value;
      this.typeSon = item.children;
    },
    getProValue (item) {
      // console.log(item);
      // 展示二级标题
      this.showTypeSon = true;
      this.typeSonSelectItem = item.value;
      // 获取商品信息
      this.listQuery.sid = item.value;
      this.getProList(this.listQuery).then(res => {
        // 解析并赋值商品信息
        item.children = res.data;
        this.proList = item.children;
        // 展示三级标题
        this.showProList = true;
      });
    },
    // 商品查询
    getProList(query) {
      return new Promise((resolve, reject) => {
        getProducts(query).then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        });
      });
    },
    // 二级、三级标题显隐控制
    // 立即执行
    setShow(tag1 = 1, tag2 = 1) {
      this.showTypeSon = tag1;
      this.showProList = tag2;
    },
    // 防抖
    setShow2: _debounce(this.timeFlag, function() {
      let [tag1, tag2] = arguments;
      this.showTypeSon = tag1;
      this.showProList = tag2;
    }, this.delay),
    selectTypeItem (item) {
      this.$router.push({
        path: '/productDetail',
        query: {
          type: 0,
          productId: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.selectBox{
  &:hover .typeItemContainer{
    display: inline-block;
    animation: changeWidth .5s;
  }
  .typeList{
    width: 250px;
    height: 100%;
    overflow-y: auto;
    background-color: rgba($color: #000000, $alpha: .3);
    .liItem{
      height: 56px;
      line-height: 56px;
      padding: 0 30px;
      color: #FFFFFF;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      cursor: pointer;
      text-align: center;
      .el-icon-arrow-right{
        float: right;
        line-height: 56px;
      }
      &:hover{
        /*background-color: #000000;*/
        background-color: rgba($color: #000000, $alpha: .6);
        text-align: center;
        /*display: flex;*/
        /*flex-wrap: wrap;*/
      }
    }
    .liActive{
      /*background-color: #000000;*/
      background-color: rgba($color: #000000, $alpha: .6);
    }
    &:hover{
      /*background-color: #888888;*/
      /*background-color: rgba($color: #000000, $alpha: .3);*/
    }
  }
  // 滚动条样式配置
  // 整个滚动条
  .typeList::-webkit-scrollbar{
    /*width: 8px;*/
    /*height: 8px;*/
    // 隐藏滚动条，但仍然可以滑动
    width: 0;
    height: 0;
  }
  // 滚动条滚动区域（轨道）
  .typeList::-webkit-scrollbar-track{
    background: #efefef;
    border-radius: 2px;
  }
  // 滚动条可拖拽的部分（滑块）
  .typeList::-webkit-scrollbar-thumb{
    background: #bfbfbf;
    border-radius: 10px;
  }
  .typeList::-webkit-scrollbar-thumb:hover{
    background: #9c9c9c;
  }

  .typeItemContainer{
    display: none;
    width: 670px;  // 显示三级标题情况下充满整个轮播图区域的宽度
    height: 100%;
    padding: 12px 8px;
    background-color: rgba($color: #FFFFFF, $alpha: .8);
    overflow-y: auto;
    .sonItem{
      display: inline-flex;
      margin: 10px 2%;
      padding: 10px 0;
      width: 21%;
      text-align: center;
      cursor: pointer;
      &:hover {
        padding: 5px 0 3px 0;
        border-bottom: #333 solid 2px;
      }

      .labelIcon{
        width: 56px;
        height: 42px;
        margin: 14px;
      }
      span{
        width: 100%;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .noTypeList{
    width: 250px;
    background-color: rgba($color: #000000, $alpha: .3);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-weight: bold;
  }
}
@keyframes changeWidth {
  from{
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/typeSelectBox4.vue